<template>
  <el-dialog
    title="开票"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal='false'
    :append-to-body="true"
    style="padding:10px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="160px" v-if="dialogVisible">
      <el-form-item>
        <div style="margin: 20px 0">
          <el-divider content-position="left">发票信息</el-divider>
        </div>
      </el-form-item>
      <el-row>
        <el-col span="12">
          <el-form-item label="抬头类型">
            <el-radio-group v-model="form.headerTypeLabel" @change="invoiceTypeChange">
              <el-radio border label="个人/非企业单位"></el-radio>
              <el-radio border label="企业单位"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="收费类型" prop="feeSort">
            <el-select v-model="form.feeSort" placeholder="请选择">
              <el-option
                v-for="item in feeSortList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item v-if="form.headerType == 2" label="纳税人识别号" prop="taxNo">
        <el-input
          v-model="form.taxNo"
          show-word-limit
          maxlength="20"
          placeholder="请输入纳税人识别号"
        ></el-input>
      </el-form-item>
      <el-form-item label="发票抬头" prop="name">
        <el-input
          v-model="form.name"
          show-word-limit
          maxlength="80"
          placeholder="请输入发票抬头"
        ></el-input>
      </el-form-item>
      <el-form-item label="发票金额" prop="amount">
        <el-input
          v-model="form.amount"
          placeholder="请输入最大6位数的金额"
          maxlength="9"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="form.headerType == 2 ? '注册地址' : '地址'">
        <el-input
          v-model="form.invoiceAdress"
          show-word-limit
          maxlength="60"
          :placeholder="form.headerType == 2 ? '请输入注册地址' : '请输入地址'"
        ></el-input>
      </el-form-item>
      <el-form-item :label="form.headerType == 2 ? '注册电话' : '电话'" prop="invoicePhone">
        <el-input
          v-model="form.invoicePhone"
          show-word-limit
          maxlength="20"
          :placeholder="form.headerType == 2 ? '请输入注册电话' : '请输入电话'"
        ></el-input>
      </el-form-item>
      <el-form-item label="开户银行">
        <el-input
          v-model="form.invoiceBank"
          show-word-limit
          maxlength="20"
          placeholder="请输入开户银行"
        ></el-input>
      </el-form-item>
      <el-form-item label="开户银行账号">
        <el-input
          v-model="form.invoiceBankNo"
          show-word-limit
          maxlength="25"
          placeholder="请输入开户银行账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="发票内容" prop="content">
        <el-input
          v-model="form.content"
          show-word-limit
          maxlength="200"
          placeholder="请输入发票内容"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div style="margin: 20px 0">
          <el-divider content-position="left">发票接收方式(至少选择一项)</el-divider>
        </div>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input
          v-model="form.phone"
          show-word-limit
          maxlength="20"
          placeholder="请输入接收发票手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="mailbox">
        <el-input
          v-model="form.mailbox"
          show-word-limit
          maxlength="50"
          placeholder="请输入接收发票邮箱"
        ></el-input>
      </el-form-item>

      <el-form-item style="margin-bottom:20px">
        <el-button type="primary" @click="submit" style="margin-right:5px">开票</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
// import { validation } from '@/util/validation';
import { getDict } from '@/api/v4ward/invoice/invoice';
export default {
  data() {
    return {
      dialogVisible: false,
      feeSortList: [],
      form: {
        taxNo: '',
        amount: '',
        phone: '',
        name: '',
        mailbox: '',
        invoiceAdress: '',
        invoicePhone: '',
        invoiceBank: '',
        invoiceBankNo: '',
        headerTypeLabel: '企业单位', //抬头类型label
        headerType: 2, //抬头类型:1-个人;2-企业
        feeSort: '',
        content: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
          { min: 1, max: 100, message: '输入长度应小于80个字符', trigger: ['change', 'blur'] },
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: ['change', 'blur'] },
          { pattern: /^[\da-zA-Z]{15,20}$/, message: '格式错误', trigger: ['change', 'blur'] },
        ],
        feeSort: [{ required: true, message: '请选择收费类型', trigger: 'blur' }],
        amount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^[1-9]\d{0,5}(\.\d{1,2})?$|^0.\d{1,2}$/,
            message: '金额格式错误或者金额过大',
            trigger: ['change', 'blur'],
          },
        ],
        invoicePhone: [
          {
            pattern: /^1\d{10}$|^(\d{3,4}-)?\d{7,8}(-\d{1,4})?$/,
            message: '格式错误',
            trigger: ['change', 'blur'],
          },
        ],
      },
      debounce: false,
    };
  },
  methods: {
    //父组件调用
    openDialog() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    invoiceTypeChange() {
      this.form.headerType = this.form.headerTypeLabel == '企业单位' ? 2 : 1;
    },
    submit() {
      if (this.debounce == true) return;
      this.debounce = true;
      this.$refs.form
        .validate()
        .then((res) => {
          if (!(this.form.mailbox || this.form.phone)) {
            this.$message({
              message: '请至少选择一个发票接收方式',
              type: 'warning',
            });
            this.debounce = false;
            return;
          }
          if (this.form.mailbox) {
            let temp = /^(\w+)(\.\w+)*@(\w+)(\.\w+)*.(\w+)$/i.test(
              this.form.mailbox
            );
            if (!temp) {
              this.$message({
                message: '邮箱格式错误',
                type: 'warning',
              });
              this.debounce = false;
              return;
            }
          }
          if (this.form.phone) {
            let tempRes = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(this.form.phone);
            if (!tempRes) {
              this.$message({
                message: '手机格式错误',
                type: 'warning',
              });
              this.debounce = false;
              return;
            }
          }
          if (this.form.headerType == 1) {
            this.form.taxNo = '';
          }
          //发票展示信息1 bankNo: invoiceBank + "-" +  invoiceBankNo
          //发票展示信息2 address: invoicePhone + "-" +  invoiceAdress
          if (this.form.invoiceBank && this.form.invoiceBankNo) {
            this.form.bankNo = this.form.invoiceBank + '-' + this.form.invoiceBankNo;
          } else {
            this.form.bankNo = this.form.invoiceBankNo || this.form.invoiceBank;
          }

          if (this.form.invoiceAdress && this.form.invoicePhone) {
            this.form.address = this.form.invoiceAdress + '-' + this.form.invoicePhone;
          } else {
            this.form.bankNo = this.form.invoiceBankNo || this.form.invoiceBank;
          }
          //
          this.$confirm('是否开票?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.$emit('submit', this.form, () => {
                this.debounce = false;
                this.dialogVisible = false;
                this.resetForm();
              });
            })
            .catch(() => {
              this.debounce = false;
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
          //
        })
        .catch((err) => {
          this.debounce = false;
          console.log('参数校验失败==>', err);
        });
    },
    resetForm() {
      this.form = {
        taxNo: '',
        amount: '',
        phone: '',
        name: '',
        mailbox: '',
        invoiceAdress: '',
        invoicePhone: '',
        invoiceBank: '',
        invoiceBankNo: '',
        headerTypeLabel: '企业单位', //抬头类型label
        headerType: 2, //抬头类型:1-个人;2-企业
        feeSort: '',
        content: '',
      };
    },
  },
  created() {
    getDict('fee_sort').then(({ data }) => {
      this.feeSortList = data;
    });
  },
};
</script>

<style scoped>
::v-deep .el-dialog__body{
  padding: 20px 30px;
}
</style>